import React from 'react'

const BlogsPage = () => {
  return (
    <h1>BlogsPage</h1>
  )
}

export default BlogsPage